import { router } from '@/config/routes';
import { RouterProvider } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { envConfig } from '@/config/envConfig';
import GlobalBackdrop from '../../atoms/BackDrop/Backdrop';

// const AppProviders: React.FC = ({}) => {
//   return (
//     <>
//       <RouterProvider router={router} />
//     </>
//   );
// };

// export default AppProviders;

const AppProviders = () => {
  //   const navigate = useNavigate();
  const origin = window.location.pathname;

  const restoreOriginalUri = (oktaAuth: OktaAuth, originalUri: string) => {
    if (originalUri) {
      window.location.href = toRelativeUrl(originalUri || '/', origin);
    }
  };

  const customAuthHandler = () => {
    window.location.href = '/login';
  };

  const config = envConfig;
  return (
    <>
      <GlobalBackdrop />
      <Security
        onAuthRequired={customAuthHandler}
        restoreOriginalUri={restoreOriginalUri}
        oktaAuth={
          new OktaAuth({
            pkce: config.pkce,
            clientId: config.clientId,
            redirectUri: config.redirectUri,
            issuer: config.issuer,
            scopes: config.scopes,
          })
        }
      >
        <RouterProvider router={router} />
      </Security>
    </>
  );
};

export default AppProviders;
